<script lang="ts">
    // @component
    // Platter icon for favorite button.

    // @cssprop --favoriteIconSize - size of favorite icon
    // @cssprop --favoriteIconStarOutline - color of star outline (unfavorited)
    // @cssprop --favoriteIconStarFill - color of filled star (favorited)
    // @cssprop --favoriteIconStarCutout - color of circle with star cutout (favorited)

    export let inFavorites: boolean;
    export let iconWeight: 'regular' | 'bold' = 'regular';
</script>

<svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    xmlns="http://www.w3.org/2000/svg"
    class="favorite-icon"
>
    {#if !inFavorites}
        <!-- Unfavorited: star outline -->
        {#if iconWeight === 'bold'}
            <path
                class="favorite-icon__star"
                d="M19.337 44.944c.851.647 1.887.448 3.031-.393l7.444-5.465 7.445 5.465c1.145.84 2.181 1.04 3.033.393.832-.63 1.006-1.68.55-2.99l-2.941-8.742 7.508-5.386c1.144-.806 1.644-1.747 1.3-2.756-.337-.992-1.282-1.476-2.679-1.459l-9.201.07-2.8-8.804c-.43-1.342-1.16-2.083-2.215-2.083-1.044 0-1.775.741-2.212 2.083l-2.8 8.805-9.21-.071c-1.389-.017-2.327.467-2.67 1.45-.345 1.018.163 1.959 1.3 2.765l7.507 5.386-2.94 8.742c-.456 1.31-.283 2.36.55 2.99zm3.418-4.686c-.022-.03-.028-.051-.007-.123l2.575-7.008c.338-.969.296-1.407-.635-2.02l-6.197-4.162c-.053-.04-.075-.071-.064-.102.01-.03.042-.039.113-.039l7.46.262c1.03.026 1.439-.212 1.716-1.215l2.025-7.175c.02-.071.04-.095.071-.095.031 0 .051.024.073.095l2.026 7.175c.277 1.003.693 1.241 1.732 1.215l7.452-.262c.071 0 .103.009.113.04.01.03-.011.052-.064.101l-6.206 4.17c-.922.614-.973 1.043-.628 2.012l2.569 7.008c.02.072.015.094-.007.123-.022.029-.053 0-.105-.033l-5.873-4.615c-.827-.648-1.326-.648-2.162 0l-5.864 4.615c-.052.033-.083.062-.113.033z"
            />
        {:else}
            <path
                class="favorite-icon__star"
                d="M18.907 45.857c.665.518 1.508.34 2.513-.39l8.575-6.305 8.592 6.305c1.005.73 1.831.908 2.512.39.665-.503.81-1.33.405-2.513L38.116 33.26l8.657-6.225c1.005-.713 1.41-1.459 1.15-2.27-.259-.777-1.02-1.166-2.269-1.15l-10.618.065-3.225-10.132c-.39-1.2-.973-1.799-1.816-1.799-.827 0-1.41.6-1.8 1.8L24.97 23.68l-10.618-.064c-1.248-.016-2.01.373-2.27 1.15-.275.811.146 1.557 1.152 2.27l8.656 6.225-3.388 10.083c-.405 1.183-.26 2.01.405 2.513Zm2.334-3.21c-.032-.033-.016-.049 0-.146l3.226-9.272c.227-.633.098-1.135-.47-1.524l-8.073-5.576c-.08-.05-.097-.081-.08-.13.016-.049.048-.049.145-.049l9.808.179c.664.016 1.086-.26 1.296-.924l2.821-9.386c.016-.098.049-.13.081-.13.049 0 .081.032.097.13l2.82 9.386c.212.664.633.94 1.298.924l9.807-.179c.097 0 .13 0 .146.049.016.049-.016.08-.081.13l-8.073 5.576c-.567.389-.697.891-.47 1.524l3.226 9.272c.016.097.032.113 0 .146-.033.048-.081.016-.146-.033l-7.797-5.949c-.519-.405-1.119-.405-1.637 0l-7.798 5.95c-.065.048-.113.08-.146.032Z"
            />
        {/if}
    {:else}
        <!-- Favorited: star cutout and fill -->
        <circle class="favorite-icon__cutout-fill" cx="30" cy="30" r="28" />
        <path
            class="favorite-icon__star-circle-fill"
            d="M30 60c16.412 0 30-13.618 30-30C60 13.588 46.382 0 29.97 0 13.588 0 0 13.588 0 30c0 16.382 13.618 30 30 30Zm-8.706-14.324c-1.765 1.353-3.647-.029-2.941-2.117l3.412-10.265-8.794-6.265c-1.647-1.205-1.089-3.558 1.147-3.529l10.794.088 3.294-10.323c.647-2.03 2.94-2.03 3.588 0l3.294 10.323 10.794-.088c2.265-.03 2.765 2.353 1.147 3.5l-8.794 6.294 3.441 10.265c.677 2.088-1.176 3.47-2.97 2.117L30 39.324l-8.706 6.352Z"
        />
    {/if}
</svg>

<style lang="scss">
    @use '@amp/web-shared-styles/app/core/globalvars' as *;

    // Default values for CSS props
    $favorite-icon-size: #{$action-button-size};
    $favorite-icon-star-outline: var(--keyColor);
    $favorite-icon-star-fill: transparent;
    $favorite-icon-star-circle-fill: var(--systemQuinary);

    .favorite-icon {
        width: var(--favoriteIconSize, #{$favorite-icon-size});
        height: var(--favoriteIconSize, #{$favorite-icon-size});
    }

    .favorite-icon__star {
        // Color of the star outline (unfavorited)
        fill: var(--favoriteIconStarOutline, #{$favorite-icon-star-outline});
    }

    .favorite-icon__cutout-fill {
        // Color of star inside cutout (favorited, bottom layer)
        fill: var(--favoriteIconStarFill, #{$favorite-icon-star-fill});
    }

    .favorite-icon__star-circle-fill {
        // Color of circle with star cut out of the center (favorited, top layer)
        fill: var(--favoriteIconStarCutout, #{$favorite-icon-star-circle-fill});
    }
</style>
